module.exports = __webpack_public_path__ + "static/media/william.ef338384.jpg";